var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};
site.search = {};
site.inits = [];

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	$('.mmLevel1 >.children', '#mainmenu2').prepend('<a class="expand" href="#"><i class="fa fa-angle-down"></i></a>');
	$('.children', '#mainmenu2 .mmLevel2').prepend('<a class="expand" href="#"><div class="first"></div><div class="second"></div></a>');
	$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4, .selectedLevel5','#mainmenu2').addClass('down');
	$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4', '#mainmenu2').find('> ul.menu').addClass('down');
	$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4', '#mainmenu2').find('> .expand').addClass('down');

	$('.children', '.subnavigation').prepend('<a class="expand" href="#"><div class="first"></div><div class="second"></div></a>');
	$('.selectedLevel2, .selectedLevel3, .selectedLevel4', '.subnavigation').find('> a.expand').addClass('down');
	$('.selectedLevel2, .selectedLevel3, .selectedLevel4', '.subnavigation').find('> ul.menu').addClass('down');
	$('.selectedLevel2, .selectedLevel3, .selectedLevel4', '.subnavigation').addClass('down');

	/*$('.level1 > a:first-child()', '#mainmenu').after('<a class="expand" href="#"><i class="fa fa-angle-down"></i></a>');
	$('.selectedLevel1,.selectedLevel2,.selectedLevel3,.selectedLevel4,.selectedLevel5','#mainmenu2').addClass('down');*/

	$('#mainmenu .mmLevel2').wrapInner('<div class="dropWrap" />');
	$('#mainmenu .level1.children > a').click(function(e) {
		e.preventDefault();
		$('body').toggleClass('dd-open');
		$parent = $(this).parent();
		$parent.toggleClass('dd');
		$parent.find('.mmLevel2').toggleClass('dd');
	});
	$('#mainmenu .level2 > a').click(function(e) {
		e.preventDefault();
	});
	$(document).mouseup(function(e) {
		var container = $('#mainmenu .level1.dd');
		var c2 = $('#mainmenu .level1.dd').find('*');
		if(!container.is(e.target) && !c2.is(e.target)) {
			site.nav.closeAll();
		}
	});

	// Expand in subnav menu
	$('.expand', '.subnavigation .mmLevel3').on('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var $ul = $this.siblings('ul');
		var $parent = $this.parent();

		$ul.toggleClass('down');
		$parent.toggleClass('down');
		$this.next().toggleClass('down');
		$this.toggleClass('down');
		e.preventDefault();
	});

	$('.level2 >a', '.subnavigation').on('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var $ul = $this.siblings('ul');
		var $parent = $this.parent();

		$ul.toggleClass('down');
		$parent.toggleClass('down');
		$this.parent().children('.expand').toggleClass('down');
	});

	site.nav.bind();
};
site.nav.closeAll = function() {
	$('#mainmenu .dd').removeClass('dd');
	$('body').removeClass('dd-open');
};


// Init search
site.search.init = function() {
	$header = $('#header');
	$searchDrop = $('#pageContainer .searchDrop');

	$header.find('.gler').click(function() {
		$this = $(this);
		if($this.hasClass('open')) {
			$('body').toggleClass('open-search');
			$this.toggleClass('open');
			$searchDrop.removeClass('open').removeAttr('style');
		}
		else {
			$('body').toggleClass('open-search');
			$this.toggleClass('open');
			$searchDrop.toggleClass('open').find('#q').focus();
		}
	});

	$searchDrop.find('.glerClose').click(function() {
		$header.find('.gler').toggleClass('open');
		$('body').toggleClass('open-search');
		$searchDrop.removeClass('open').removeAttr('style');
	});
};


// Prepend search to mobile menu
site.nav.prependSearch = function() {
	var $searchForm = $('#searchForm');
	var $menu = $('ul.mmLevel1', '#mainmenu2');

	$menu.prepend($searchForm.clone());
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu2').bind('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var $ul = $this.siblings('ul');
		var $parent = $this.parent();

		$ul.toggleClass('down');
		$parent.toggleClass('down');
		$this.next().toggleClass('down');
		$this.toggleClass('down');
		e.preventDefault();
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};



// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	site.nav.init();
	site.search.init();
	site.nav.prependSearch();
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});


	$('a[href*=#]:not([href=#])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-135
				}, 500);
				return false;
			}
		}
	});

	if ($(window.location.hash).offset()) {
		$('html,body').animate({
			scrollTop: $(window.location.hash).offset().top-135
		}, 1);
	}






	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);
});

// Sticky header

var timer;
$(window).scroll(function() {

	if(timer) {
		window.clearTimeout(timer);
	}

	timer = window.setTimeout(function() {
		var body = $('body'),
			scroll = $(window).scrollTop();

		if (scroll >= 38) body.addClass('stickyHead');
		else body.removeClass('stickyHead');
	}, 10);
});
